export default __webpack_public_path__ + "static/media/hibernate.49032b65.png";